<template>
  <div class="list-item" :style="cruiseBg(cruise)" @click="goToCruiseDetail()">
    <div class="list-item-img-con">
      <img class="list-item-img" :src="cruise.pcImage" />
      <div class="list-item-tag" v-if="isHot">
        <div class="list-item-tag-text">爆款</div>
      </div>
      <div class="list-item-bottom" v-if="isHot">
        {{ cruise.supportDescription }}
      </div>
      <div v-if="cruise.isShowDeadlineSaleCountdown" class='salesCountdownBar'>

        <div class="salesCountdownBar-div">距关闭</div>
        <uCountDown  :timestamp="cruise.deadlineSaleCountdownTotalSeconds"/>
                
      </div>
    </div>
    <div class="list-item-con">
      <div class="item-title-con">
        <div class="item-title float-left">{{ cruise.cruiseName }}</div>
        <div
          class="like-con"
          :class="{ active: cruise.inWish }"
          @click.stop="onWishListClick"
        >
          <img
            class="inWishlistImage cruise--list__Wish-img"
            src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/like-checked.jpg"
          />
          <img
            class="notInWishlistImage cruise--list__Wish-img"
            src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/like-def.jpg"
          />

          <div style="line-height: 12px" class="wishlistCount">
            {{ cruise.collections }}
          </div>
        </div>
      </div>
      <div class="item-info-text fc-txt-1">
        {{ routeDaysStr }}
        <span style="display: inline-block; margin-left: 18px">{{
          cruise.shipCNName
        }}</span>
      </div>
      <div class="item-info-text">
        <div class="float-left">
          {{ cruise.sailDateBegin }} <i>—</i> {{ cruise.sailDateEnd }}
        </div>
        <div class="item-more-date" @click.stop="onMoreSailDateClick">
          <img
            class="float-left"
            style="margin-right: 5px"
            src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-date-1.jpg"
          />
          <div class="float-left fw-400">更多日期</div>
        </div>
      </div>

      <div class="item-tag-con" style="overflow: hidden">
        <div class="list-search-input-tag-con">
          <CruiseTag
            v-for="(tag, i) in tags"
            :key="'tag_' + i"
            :tag="tag"
            :index="new Date().getTime() + '_' + i"
          />
        </div>
      </div>
      <div class="item-btn-con" v-if="cruise.netAmount && cruise.netAmount > 0">
        <div class="item-left">
          <div class="item-text">
            {{ guestNumberText }}{{ nrpText }}(含税)
          </div>
          <div class="item-price">
            <span class="price">￥<span>{{ netAmount }}</span>/人起</span>
<!--            <full-board-details :is-fold="isFold" :target-str="`tooltip-${cruise.cruiseId}`" :container-str="`container-${cruise.cruiseId}`">-->

<!--            </full-board-details>-->
<!--            <el-tooltip placement="top-start" effect="light">-->
<!--              <span class="link" :id="'tooltip-'+cruise.cruiseId">船票包含</span>-->
<!--              <div slot="content">-->
<!--                fsdafasdf-->
<!--              </div>-->
<!--            </el-tooltip>-->
<!--            <el-tooltip class="item" effect="dark" content="Top Left 提示文字" placement="top-start">-->
<!--              <span class="link">船票包含</span>-->
<!--            </el-tooltip>-->

            <el-popover
            v-if="showRow"
                placement="top-start"
                title=""
                width="480"
                offset="10"
                trigger="hover">
              <span class="link" slot="reference" :id="'tooltip-'+cruise.cruiseId">船票包含</span>
              <full-board-details></full-board-details>
            </el-popover>
          </div>
          <div class="item-text" v-if="cruise.amountPerNight">
            <span class="through">￥<span>{{ cruise.originalAmount }}</span>/人起</span>
            <span>平均每晚￥{{ amountPerNight }}/人起</span>
          </div>
        </div>
        <div class="item-right">
          <div class="item-deposit">
            <template v-if="cruise.isDownPayCruise">
               <div class="item-deposit-con"> <img class="item-deposit-icon" :src='`${imgUrl}/cruiseSearch/icons/deposit-currency-symbol.svg`' />
                <span>支持订金预订¥1000/人起</span>
               </div>
            </template>

            <template v-if="!cruise.isSale || (cruise.isShowDeadlineSaleCountdown == true && cruise.deadlineSaleCountdownTotalSeconds <= 0)">
              <span style="color: #0568be;font-size: 10px;line-height: 16px">*此航线不可售卖，请联系在线客服或拨打400-820-7786 进行预订</span>
            </template>
          </div>
          <div v-if="cruise.isSale || (cruise.isShowDeadlineSaleCountdown == true && cruise.deadlineSaleCountdownTotalSeconds > 0)" class="item-btn" @click.stop="goToCruiseDetail()">
            <span>立即预订</span>
            <img :src='`${imgUrl}/cruiseSearch/icons/icon-arrow-right.png`' />
          </div>
          <div v-else class="item-btn" style="background: #f0f0f0" @click.stop="goToCruiseDetail()">
            <span>联系客服</span>
          </div>
        </div>
      </div>
      <div
        class="item-btn-con"
        v-if="!cruise.netAmount || cruise.netAmount <= 0"
      >
        <div class="item-null">
          <img
            src="https://resource.rcclchina.com.cn/cruiseSearch/pc/soldout.png"
          />
        </div>
      </div>

<!--      <div v-if="isShowPopular" class="item-info-intro">-->
<!--        <div class="item-info-icon">人气</div>-->
<!--        <div class="item-info-time">-->
<!--          <p v-if="cruise.searchCount > 10">-->
<!--            过去6小时内有<span class="item-number">{{-->
<!--              cruise.searchCount-->
<!--            }}</span-->
<!--            >人搜索过该航线-->
<!--          </p>-->
<!--          <p v-if="cruise.bookingCount > 10">-->
<!--            过去6小时内该航线已被预订<span class="item-number">{{-->
<!--              cruise.bookingCount-->
<!--            }}</span-->
<!--            >次-->
<!--          </p>-->
<!--        </div>-->
<!--      </div>-->
      <div v-if="isShowNearRoutePopup" class="near-route-con">
        <div class="near-route-popup">
          <div class="near-route-logo"><img src="https://resource.rcclchina.com.cn/logo/PC/logoPopup.png" alt=""></div>
          <div class="near-route-text">此航线{{ routePopupText }}，请联系在线客服或
            拨打400-820-7786 进行预订。</div>
          <div class="near-route-btn" @click.stop="closeRoutePopup">我知道了</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const CruiseTag = () => import("@/components/Cruise/CruiseTag.vue");
const uCountDown = () => import("@/components/Cruise/uCountDown");

const FullBoardDetails = () => import("@/components/Cruise/FullBoardDetails.vue");
import {gioTracking} from "@/utilities/tools";
import api from "@/api";

export default {
  name: "CruiseSearchItem",
  components: {
    CruiseTag,
    uCountDown,
    FullBoardDetails
  },
  props: {
    cruise: {
      type: Object,
      default() {
        return {};
      },
    },
    showLoginPopup: {
      type: Function,
    },
    showRow: {
      type: Boolean,
      default() {
        return true;
      },
    },
  },
  data() {
    return {
      isFold: false,
      imgUrl: process.env.VUE_APP_IMG_URL,
      isShowNearRoutePopup:false,
      routePopupText:''
    }
  },
  methods: {
    goToCruiseDetail() {

      if(!this.cruise.isSale || (this.cruise.isShowDeadlineSaleCountdown == true && this.cruise.deadlineSaleCountdownTotalSeconds <= 0)){
        this.isShowNearRoutePopup = true
        this.routePopupText = '不可售卖'
        return;
      }
      this.gio();
			window.open(`/Rccl.Cruise/CruiseDetail?shipCode=${this.cruise.shipCode}&sailDate=${this.cruise.sailDate}`)
      // this.$router.push({
      //   name: "CruiseDetail",
      //   query: {
      //     shipCode: this.cruise.shipCode,
      //     sailDate: this.cruise.sailDate,
      //   },
      // });
    },
    onWishListClick() {
      if (this.cruise.inWish) {
        this.deleteWishList();
      } else {
        this.addWishList();
      }
    },
    onMoreSailDateClick() {
      this.$emit("onMoreSailDateClick", {
        sailDate: this.cruise.sailDate,
        cruiseName: this.cruise.cruiseName,
        shipCode: this.cruise.shipCode,
      });
    },
    async addWishList() {
      const userToken = this.$store.state.user.userToken;
      if (!userToken || userToken.length == 0) {
        const self = this;
        this.showLoginPopup(() => {
          self.addWishList();
        });
        // let self = this
        // this.$confirm.show('您尚未登录， 请登录之后， 再添加至心愿单', {
        //     confirmCallBack: () => {
        //         self.$router.push({ name: 'Login', query:{
        //             returnUrl: location.href
        //         }})
        //     }
        // })
        return;
      }
      const requestData = {
        userName: userToken,
        cruiseId: this.cruise.cruiseId,
        source: "PC",
      };
      this.$loading.show();
      const { success } = await api.cruise.addWishList(requestData);
      if (success) {
        this.cruise.inWish = true;
        this.cruise.collections++;
      }
      this.$loading.hide();
    },
    async deleteWishList() {
      const userToken = this.$store.state.user.userToken;
      if (!userToken || userToken.length == 0) {
        let self = this;
        this.$confirm.show("您尚未登录， 请登录之后， 再添加至心愿单", {
          confirmCallBack: () => {
            self.showLoginPopup(() => {
              self.deleteWishList();
            });
          },
        });
        return;
      }
      const requestData = {
        userName: userToken,
        cruiseId: this.cruise.cruiseId,
        source: "PC",
      };
      this.$loading.show();
      const { success } = await api.cruise.deleteWishList(requestData);
      if (success) {
        this.cruise.inWish = false;
        if (this.cruise.collections > 0) {
          this.cruise.collections--;
        }
      }
      this.$loading.hide();
    },
    gio () {
      gioTracking('track', 'evt_CruiseList', {
        shipCode:this.cruise.shipCode || 'nil',
        sailDate:this.cruise.sailDate || 'nil'
      })
    },
    // 关闭联系客服弹窗
    closeRoutePopup(){
      this.isShowNearRoutePopup = false
      this.routePopupText = ''
    },
    cruiseBg(obj) {
      let cruiseBg = "";
      if(obj.backgroundImageCategory && obj.backgroundImageCategory === "QIAOHU") {
        cruiseBg = `background-image: url('${obj.pcCruiseBackgroundImage}');`;
      }
      if(!obj.isSale || (obj.isShowDeadlineSaleCountdown == true && obj.deadlineSaleCountdownTotalSeconds <= 0)) {
        cruiseBg = "background-color:#FFF";
      }
      return cruiseBg
    }
  },
  computed: {
    
    supportDescription() {
      return this.cruise.supportDescription;
    },
    sailDateBegin() {
      return this.cruise.sailDateBegin
        ? this.cruise.sailDateBegin.split(" (")[0]
        : "";
    },
    sailDateEnd() {
      return this.cruise.sailDateEnd
        ? this.cruise.sailDateEnd.split(" (")[0]
        : "";
    },
    cruiseUrl() {
      return (
        "/Rccl.Cruise/CruiseDetail?sailDate=" +
        this.cruise.sailDate +
        "&shipCode=" +
        this.cruise.shipCode +
        "&guestNumber=" +
        this.cruise.guestNumber
      );
    },
    isHot() {
      return this.cruise.choosenSupport;
    },
    routeDaysStr() {
      return this.cruise.routeDays + "天" + (this.cruise.routeDays - 1) + "晚";
    },
    tags() {
      return this.cruise.tags
        ? this.cruise.tags.filter((r) => r.tagType && r.tagType.length > 0)
        : [];
    },
    guestNumberText() {
      switch (this.cruise.priceGuestNumber) {
        case 1:
          return "单人房";
        case 2:
          return "双人房";
        case 3:
          return "三人房";
        case 4:
          return "四人房";
        default:
          return "";
      }
    },
    nrpText() {
      return this.cruise.isnrpPrice ? "早订特惠价" : "优惠价";
    },
    netAmount() {
      return this.cruise.netAmount ? this.cruise.netAmount.toFixed(0) : "";
    },
    amountPerNight() {
      return this.cruise.amountPerNight
        ? this.cruise.amountPerNight.toFixed(0)
        : "";
    },
    isShowPopular() {
      return (
        (this.cruise.bookingCount >= 10 || this.cruise.searchCount >= 10) &&
        this.cruise.bookingCount + this.cruise.searchCount >= 100
      );
    },
  },
};
</script>

<style lang="less" scoped>
.bs-tooltip-top .arrow:before {
  bottom: 0;
  border-width: 0 15px 15px;
  border-bottom-color: #54A3DE;
}
.list-item {
  background-color: #fff;
  margin-bottom: 10px;
  padding: 10px;
  overflow: hidden;
  position: relative;
  border: solid 2px transparent;
  background-size: cover;
  background-position: top;
  background-repeat: no-repeat;
  .list-item-img-con {
    width: 237px;
    height: 239px;
    position: relative;
    float: left;
    img {
      width: 100%;
      height: 100%;
    }
    .list-item-tag {
      width: 108px;
      height: 37px;
      background: url(https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/bg-tag-1.jpg)
        no-repeat 100%;
      position: absolute;
      top: 10px;
      left: -5px;
      .list-item-tag-text {
        height: 28px;
        line-height: 28px;
        color: #fff;
        text-align: center;
      }
    }
    .list-item-bottom {
      width: 100%;
      padding: 10px 0;
      background: linear-gradient(to bottom, rgba(40, 43, 44, 0.3), #282b2c);
      position: absolute;
      bottom: 0px;
      left: 0px;
      font-size: 14px;
      color: #ffffff;
      text-align: center;
    }
    .salesCountdownBar {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0 4px;
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      z-index: 1;
      width: 220px;
      height: 36px;
      background-image: url('https://resource.rcclchina.com.cn/wechatMiniProgram/shipRoutesList/salesCountdownTitleBgPC.png');
      background-size: 100% 100%;
      
    }
    .salesCountdownBar-div{
        font-size: 18px;
        height: 22px;
        line-height: 22px;
        color: #fff;
      }
    .salesCountdownBar-span{
        display: flex;
        justify-content: center;
        padding: 1px 2px;
        border-radius: 3px;
        background-color: #fff;
        
    }
    .salesCountdownBar-span-text{
      color: #FA531F;
      font-size: 19px;
      line-height: 1;
    }
  }
  .list-item-con {
    margin-left: 18px;
    width: 640px;
    float: left;
    .item-title-con {
      font-size: 22px;
      line-height: 30px;
      color: #282b2c;
      overflow: hidden;
      .item-title {
        max-width: 510px;
        margin-top: 5px;
        font-weight: 600;
        letter-spacing: 0;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
      .item-details {
        text-decoration: underline;
        margin-top: 5px;
        margin-left: 5px;
        padding-right: 15px;
        font-size: 16px;
        color: #006ab9;
      }
      .like-con {
        font-size: 12px;
        color: #747d80;
        float: right;
        text-align: center;
        cursor: pointer;
        position: absolute;
        top: 12px;
        right: 14px;
        .inWishlistImage {
          display: none;
        }
        .notInWishlistImage {
          display: inline;
        }
      }
      .like-con.active {
        .inWishlistImage {
          display: inline;
        }
        .notInWishlistImage {
          display: none;
        }
      }
    }
    .item-info-text {
      font-size: 14px;
      color: #282b2c;
      overflow: hidden;
      margin-top: 5px;
      .item-more-date {
        color: #006ab9;
        margin-left: 8px;
        float: left;
        line-height: 16px;
        margin-top: 3px;
        cursor: pointer;
      }
      &.fc-txt-1 {
        color: #a6aeb1;
      }
    }
    .item-tag-con {
      margin-top: 5px;
      overflow: hidden;
      margin-bottom: 11px;
      .list-search-input-tag-con {
        margin-top: 3px;
        //width: 515px;
        max-height: 66px;
      }
    }
    .item-btn-con {
      position: absolute;
      margin-top: 14px;
      float: right;
      right: 13px;
      bottom: 10px;
      width: 640px;
      overflow: hidden;
      .item-left {
        float: left;
        .item-price {
          .price {
            font-size: 12px;
            font-weight: bold;
            color: #f8a70e;
            & > span {
              font-size: 28px;
            }
          }
          .link{
            margin-left: 25px;
            font-size: 12px;
            color: #0073bb;
          }
        }
        .item-text {
          font-size: 12px;
          color: #a6aeb1;
          .through {
            margin-right: 25px;
            text-decoration: line-through;
          }
        }
      }

      .item-right {
        float: right;
        .item-deposit {
          //height: 20px;
          text-align: right;
          font-size: 12px;
          color: #282b2c;
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          justify-content: flex-end;
          .item-deposit-con{
            display: flex;
            align-items: center;
            justify-content: center;
            width: 170px;
            height: 20px;
            background: #FFF1DC;
            border-radius: 10px;
            font-weight: 500;
            font-size: 12px;
            color: #CF7F28;
            gap: 2.5px;
            .item-deposit-icon{
              width: 12px;
              height: 12px;
            }
          }
        }
        .item-btn {
          margin-top: 6px;
          width: 228px;
          height: 50px;
          background-color: #fbc500;
          font-size: 22px;
          color: #282b2c;
          text-align: center;
          float: right;
          font-weight: 500;
          cursor: pointer;
          padding-top: 9px;
          & > span {
            height: 32px;
            line-height: 32px;
            display: inline-block;
          }
          & > img {
            height: 14px;
            margin: -4px 0 0 8px;
            display: inline-block;
          }
        }
      }
    }
    .item-info-intro {
      display: flex;
      .item-info-icon {
        background: #fbc500;
        width: 44px;
        height: 23px;
        text-align: center;
        color: #282b2c;
        line-height: 22px;
        font-size: 14px;
        margin-right: 7px;
      }
      .item-info-time p {
        display: inline-block;
        font-size: 14px;
        color: #282b2c;
        & + p {
          margin-left: 10px;
          padding-left: 10px;
          border-left: 1px solid #dddddd;
        }
        .item-number {
          color: #ffa70d;
          font-weight: bold;
        }
      }
    }
  }
}
.list-item:hover {
  cursor: pointer;
  border: solid 2px #fbc300;
}

.item-null {
  position: absolute;
  right: -4px;
  top: -72px;
  transform: rotate(15deg);
}
.near-route-con{
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0,0,0,0.6);
  width: 100%;
  height: 100vh;
  z-index: 999;
}
.near-route-popup{
  width: 585px;
  height: 276px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom: 24px;
  color: #000;
}
.near-route-logo{
  width: 80px;
  height: 76px;
  margin: 0 auto;
}
.near-route-logo img {
  height: 100%;
  margin-top: 10px;
}
.near-route-text{
  font-size: 22px;
  line-height: 30px;
  text-align: center;
  padding: 0 108px;
}
.near-route-btn{
  width: 152px;
  height: 48px;
  font-size: 22px;
  line-height: 48px;
  margin: 0 auto;
  text-align: center;
  background: linear-gradient(to bottom,#ffd500,#ffbf00);
  border-radius: 3px;
}
</style>
<style lang="css">
.el-popper[x-placement^=top]{
  margin-bottom: 20px !important;
}
.el-popper[x-placement^=top] .popper__arrow {
  bottom: -16px;
}
.el-popper .popper__arrow {
  border-width: 15px;
}
.el-popper[x-placement^=top] .popper__arrow::after {
  bottom: 2px;
  margin-left: -15px;
}
.el-popper .popper__arrow::after {
  content: " ";
  border-width: 15px;
}
</style>
